import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { registerAppNavigate } from "../utils/appNavigateBridge";

/** Registra `useNavigate` para helpers que abrem rotas do workspace fora de componentes. */
export default function AppNavigateBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    registerAppNavigate(navigate);
    return () => registerAppNavigate(null);
  }, [navigate]);

  return null;
}
